import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Navigate } from 'react-router-dom';

import { PublicRoute } from './index';
import { Loading } from '../../cdui';

const AllowApplicationRoute = ({ redirectPath = '/', children, isConfigLoading, type }) => {
  const location = useLocation();

  const {
    allowTenantApplications,
    allowLandlordApplications,
  } = useSelector((state) => state.configs);

  const { isPassedPrescreening, isLoggedIn } = useSelector((state) => state.auth);

  // Check if the user is already logged in
  if (isLoggedIn) return <Navigate to={`/application/${type}`} replace from={{ from: location }} />;

  // Wait for fetching the configuration
  if (isConfigLoading) {
    return (
      <PublicRoute>
        <Loading main />
      </PublicRoute>
    );
  }

  // Check if the application is allowed
  if (
    (type === 'tenant' && allowTenantApplications && allowTenantApplications.toLowerCase() === 'yes' && isPassedPrescreening) ||
    (type === 'landlord' && allowLandlordApplications && allowLandlordApplications.toLowerCase() === 'yes')
  ) {
    return children;
  }

  return <Navigate to={redirectPath} replace from={{ from: location }} />;
};

AllowApplicationRoute.propTypes = {
  redirectPath: PropTypes.string,
  children: PropTypes.element,
  isConfigLoading: PropTypes.bool,
  type: PropTypes.string,
};

export default AllowApplicationRoute;
